import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ExtField.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "page-info font-size-h2-normal"
  }, [_c('div', {
    staticClass: "field vux-1px-b"
  }, [_c('div', {
    staticClass: "field-line"
  }, [_c('div', {
    staticClass: "field-line-label"
  }, [_vm._v(i18n.tc("614"))]), _c('div', {
    staticClass: "field-line-value"
  }, [_vm._v(_vm._s(_vm.eventTmpl.name))])]), _c('div', {
    staticClass: "field-line"
  }, [_c('div', {
    staticClass: "field-line-label"
  }, [_vm._v(i18n.tc("69"))]), _c('div', {
    staticClass: "field-line-value"
  }, _vm._l(_vm.serviceList, function (item, index) {
    return _c('span', {
      key: item.id
    }, [_vm._v(" " + _vm._s(item.service_name) + " - " + _vm._s(item.service_num) + _vm._s(item.unit || i18n.tc("479")) + " ")]);
  }), 0)]), _c('div', {
    staticClass: "field-line"
  }, [_c('div', {
    staticClass: "field-line-label"
  }, [_vm._v(i18n.tc("615"))]), _c('div', {
    staticClass: "field-line-value"
  }, [_vm._v(" " + _vm._s(_vm.priorityMap[_vm.eventInfo.priority]) + " ")])]), _c('div', {
    attrs: {
      "id": "page-extField"
    }
  }, [_c(__unplugin_components_0, {
    attrs: {
      "size": "h2",
      "extFields": _vm.eventExtFields
    }
  })], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };